import { Deployment } from "../../../types/Deployment";
import { toTemporalZonedDateTime } from "../../../shared/lib/temporal";

/**
 * Sort deployments by creation date (newest first)
 */
export function sortByCreatedDesc(deployments: Deployment[]): Deployment[] {
    return [...deployments].sort(
        (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime(),
    );
}

/**
 * Find the deployment that contains a given date (day-level, timezone-aware)
 */
export function findDeploymentForDate(
    deployments: Deployment[],
    date: Date,
    timezone: string,
): Deployment | null {
    const targetDate = toTemporalZonedDateTime(date, timezone).toPlainDate();
    return (
        deployments.find((d) => {
            const startDate = toTemporalZonedDateTime(
                d.startTime,
                timezone,
            ).toPlainDate();
            const endDate = toTemporalZonedDateTime(
                d.endTime,
                timezone,
            ).toPlainDate();
            return (
                Temporal.PlainDate.compare(targetDate, startDate) >= 0 &&
                Temporal.PlainDate.compare(targetDate, endDate) <= 0
            );
        }) || null
    );
}
